import {Card, Col, Row} from "react-bootstrap";
import React from "react";

export default function ColumnCard(props) {
    return (<Col md={props.mdSize} style={props.style}>
        <Card>
            <Card.Body bsPrefix={props.customStyle ? 'custom-card-body' : 'card-body'}>
                <Row>
                    <Col md={12}>
                        <props.component variant={props.variant || null}
                                         entityType={props.entityType || null}
                                         title={props.title}
                                         entityLabel={props.entityLabel || null}

                        />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    </Col>)
}